export const MODE_GRID = "G";
export const MODE_LIST = "L";

const INITIAL_STATE = {
  // show home mode
  showHomeProductsMode: MODE_GRID,
};

const createLayoutSlice = (set) => ({
  ...INITIAL_STATE,

  showHomeAsGrid: () => {
    set({ showHomeProductsMode: MODE_GRID });
  },
  showHomeAsList: () => {
    set({ showHomeProductsMode: MODE_LIST });
  },
  resetLayoutSlice: () => {
    set({
      INITIAL_STATE,
    });
  },
});

export default createLayoutSlice;
